import React from 'react'
import { Button } from '@mui/material'
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined'

import {
  type AccountChargeRunReportName,
  useDownloadAccountChargeRunReportCsvLazyQuery
} from '../../../../api-services/asset-holdings/accountChargeRunApi'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../../app/hooks'
import { setNotification } from '../../../components/ui-widgets/uiWidgetsSlice'
import ButtonLoadingComponent from '../../../../views/components/shared/ButtonLoadingComponent'

interface Props {
  chargeMonth: string
  reportName: AccountChargeRunReportName
  label: string
}

const DownloadAccountChargeRunReportButton: React.FC<Props> = ({ chargeMonth, reportName, label }) => {
  const dispatch = useAppDispatch()
  const [trigger, { isFetching }] = useDownloadAccountChargeRunReportCsvLazyQuery()

  const handleDownload = (): void => {
    trigger({ chargeMonth, reportName })
      .unwrap()
      .then((result) => {
        const blob = new Blob([result.csv], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = result.filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      })
      .catch((err) => {
        dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
      })
  }

  return (
    <Button
      variant={'outlined'}
      color={'primary'}
      disabled={isFetching}
      startIcon={<DownloadOutlinedIcon />}
      onClick={handleDownload}
      sx={{ textTransform: 'none' }}
    >
      {label}
      { isFetching && <ButtonLoadingComponent /> }
    </Button>
  )
}

export default DownloadAccountChargeRunReportButton
